import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { useState } from 'react'
import ECharts from '~/components/echarts'
import {
  azureDiskCostAnalysisChartOrganizationOptimizerAzureMasterOptimizationsPath,
  azureDiskVolumeKindCurrentChartOrganizationOptimizerAzureMasterOptimizationsPath,
  azureDiskVolumeKindOptimizedChartOrganizationOptimizerAzureMasterOptimizationsPath,
} from '~/routes'

export default function DiskOptimization({ organizationId, masterOptimizationId, masterOptimization }) {
  const [activeTab, setActiveTab] = useState('cost-analysis')

  if (!masterOptimization) {
    return null
  }

  const handleTabChange = (tabId) => {
    setActiveTab(tabId)
  }

  const getDiskCostAnalysisChartUrl = (orgId) =>
    azureDiskCostAnalysisChartOrganizationOptimizerAzureMasterOptimizationsPath({ organization_id: orgId })

  const getDiskVolumeKindCurrentChartUrl = (orgId) =>
    azureDiskVolumeKindCurrentChartOrganizationOptimizerAzureMasterOptimizationsPath({ organization_id: orgId })

  const getDiskVolumeKindOptimizedChartUrl = (orgId) =>
    azureDiskVolumeKindOptimizedChartOrganizationOptimizerAzureMasterOptimizationsPath({ organization_id: orgId })

  return (
    <div className='row mb-4'>
      <div className='col-12'>
        <div className='card'>
          <div className='card-header'>
            <div className='d-flex justify-content-between align-items-center'>
              <h5 className='card-title mb-0'>
                <Trans>Azure Disk Optimization</Trans>
              </h5>
            </div>
          </div>
          <div className='card-body'>
            <ul className='nav nav-tabs'>
              <li className='nav-item' role='presentation'>
                <button
                  className={`nav-link ${activeTab === 'cost-analysis' ? 'active' : ''}`}
                  onClick={() => handleTabChange('cost-analysis')}
                  type='button'
                  role='tab'
                >
                  <Trans>Cost Analysis</Trans>
                </button>
              </li>
              <li className='nav-item' role='presentation'>
                <button
                  className={`nav-link ${activeTab === 'volume-kind' ? 'active' : ''}`}
                  onClick={() => handleTabChange('volume-kind')}
                  type='button'
                  role='tab'
                >
                  <Trans>Volume Kind Charts</Trans>
                </button>
              </li>
            </ul>

            <div className='mt-3'>
              {activeTab === 'cost-analysis' && (
                <div>
                  <ECharts
                    title={t`Daily Cost Comparison`}
                    chartInfoTitle='azure_disk_optimization_daily_cost_comparison'
                    url={getDiskCostAnalysisChartUrl(organizationId)}
                    params={{ master_optimization_id: masterOptimizationId }}
                  />
                </div>
              )}

              {activeTab === 'volume-kind' && (
                <div className='row'>
                  <div className='col-md-6'>
                    <ECharts
                      title={t`Volume Kind - Current`}
                      chartInfoTitle='azure_disk_volume_kind_current'
                      url={getDiskVolumeKindCurrentChartUrl(organizationId)}
                      params={{ master_optimization_id: masterOptimizationId }}
                    />
                  </div>
                  <div className='col-md-6'>
                    <ECharts
                      title={t`Volume Kind - Optimized`}
                      chartInfoTitle='azure_disk_volume_kind_optimized'
                      url={getDiskVolumeKindOptimizedChartUrl(organizationId)}
                      params={{ master_optimization_id: masterOptimizationId }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
